import deepFreeze from 'deep-freeze';
import serviceFactory from '@/services/serviceFactory';

export const ENDPOINTS = deepFreeze({
    EXPORT_SPACES_REPORTS: {
        URI: () => '/api/v1/spaces/{{spaceId}}/export-reports{{/id?}}',
        methods: ['get', 'post', 'delete'],
        cache: false,
    },
    EXPORT_PRODUCTS_PRICE_REPORTS: {
        URI: () => '/api/v1/spaces/{{spaceId}}/products-price-report-export{{/id?}}',
        methods: ['get', 'post', 'delete'],
        cache: false,
    },
    EXPORT_COMPETITION_REPORTS: {
        URI: () => '/api/v1/spaces/{{spaceId}}/competition-report-export{{/id?}}',
        methods: ['get', 'post', 'delete'],
        cache: false,
    },
    EXPORT_PRODUCTS_AVAILABILITY_REPORTS: {
        URI: () => '/api/v1/spaces/{{spaceId}}/products-availability-report-export{{/id?}}',
        methods: ['get', 'post', 'delete'],
        cache: false,
    },
});

export const exportReportStatus = Object.freeze({
    PENDING: 'pending',
    GENERATING: 'generating',
    GENERATED: 'generated',
    PARTIAL: 'partial',
    CORRUPTED: 'corrupted',
});

export default {
    ...serviceFactory.build(ENDPOINTS),
};
